// @ts-nocheck
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { DragDropContext } from '@hello-pangea/dnd'

import Button from 'js/components/Button'
import FormItem from 'js/components/Form/FormItem'
import { Container } from 'js/components/Grid'
import Setting from 'js/components/Setting'
import Spacer from 'js/components/Spacer/Spacer'

import NavigationMenu from './components/NavigationMenu'

const NavigationTab = ({ entity, groupPages, menu, setMenu }) => {
    const { control } = useFormContext()

    const { t } = useTranslation()

    const newPageTemplate =
        groupPages?.length > 0
            ? {
                  type: 'page',
                  id: groupPages[0].guid,
                  access: 'public',
              }
            : {
                  type: 'plugin',
                  id: 'blog',
                  access: 'public',
              }

    const onDragEnd = (result) => {
        if (!result.destination) {
            return
        }

        const sourceIndex = result.source.index
        const destinationIndex = result.destination.index

        if (result.type === 'SUBMENU') {
            const source = JSON.parse(result.source.droppableId)
            const destination = JSON.parse(result.destination.droppableId)

            const newSource = [...menu[source.index].submenu]
            const [movedPage] = newSource.splice(sourceIndex, 1)

            if (newSource.length === 0) {
                setMenu((prev) =>
                    prev.map((item, idx) =>
                        idx === source.index ? newPageTemplate : item,
                    ),
                )
            }

            if (source.index === destination.index) {
                newSource.splice(destinationIndex, 0, movedPage)
            }

            setMenu((prev) =>
                prev.map((item, idx) =>
                    idx === source.index
                        ? { ...item, submenu: newSource }
                        : item,
                ),
            )

            if (source.index !== destination.index) {
                const newDestination = [...menu[destination.index].submenu]
                newDestination.splice(destinationIndex, 0, movedPage)

                setMenu((prev) =>
                    prev.map((item, idx) =>
                        idx === destination.index
                            ? { ...item, submenu: newDestination }
                            : item,
                    ),
                )
            }
        } else {
            const newPages = [...menu]
            const [movedPage] = newPages.splice(sourceIndex, 1)
            newPages.splice(destinationIndex, 0, movedPage)
            setMenu(newPages)
        }
    }

    const handleClickAdd = (evt, index) => {
        if (index !== undefined) {
            const newSubmenu = [...(menu[index].submenu || []), newPageTemplate]
            setMenu((prev) =>
                prev.map((item, idx) =>
                    idx === index
                        ? {
                              label: item.label || '',
                              type: 'submenu',
                              access: item.access,
                              submenu: newSubmenu,
                          }
                        : item,
                ),
            )
        } else {
            setMenu([...menu, newPageTemplate])
        }
    }

    const handleRemove = (index, parentIndex) => {
        if (parentIndex !== undefined) {
            setMenu((prev) =>
                prev.map((item, idx) => {
                    if (idx === parentIndex) {
                        const submenu = item.submenu.filter(
                            (_, sIdx) => sIdx !== index,
                        )
                        if (submenu.length === 0) {
                            return { ...newPageTemplate, access: item.access }
                        }
                        return { ...item, submenu }
                    }
                    return item
                }),
            )
        } else {
            setMenu((prev) => prev.filter((_, idx) => idx !== index))
        }
    }

    const handleChangePage = (val, index, parentIndex) => {
        if (parentIndex !== undefined) {
            setMenu((prev) =>
                prev.map((item, idx) =>
                    idx === parentIndex
                        ? {
                              ...item,
                              submenu: item.submenu.map((subItem, sIdx) =>
                                  sIdx === index ? val : subItem,
                              ),
                          }
                        : item,
                ),
            )
        } else {
            setMenu((prev) =>
                prev.map((item, idx) => (idx === index ? val : item)),
            )
        }
    }

    const handleChangeAccess = (val, index, parentIndex) => {
        if (parentIndex !== undefined) {
            setMenu((prev) =>
                prev.map((item, idx) =>
                    idx === parentIndex
                        ? {
                              ...item,
                              submenu: item.submenu.map((subItem, sIdx) =>
                                  sIdx === index
                                      ? { ...subItem, access: val }
                                      : subItem,
                              ),
                          }
                        : item,
                ),
            )
        } else {
            setMenu((prev) =>
                prev.map((item, idx) =>
                    idx === index ? { ...item, access: val } : item,
                ),
            )
        }
    }

    const handleChangeLabel = (val, i) => {
        setMenu((prev) =>
            prev.map((item, idx) =>
                idx === i ? { ...item, label: val } : item,
            ),
        )
    }

    const groupPageOptions = groupPages.map((page) => {
        return {
            value: page.guid,
            label: page.title,
        }
    })

    return (
        <Container size="small" style={{ marginTop: '24px' }}>
            <Spacer>
                {/* Only show start page setting if group exists */}
                {entity && (
                    <Spacer spacing="small">
                        <FormItem
                            control={control}
                            type="select"
                            name="startPage"
                            title={t('entity-group.home-page')}
                            description={t('entity-group.home-page-helper')}
                            label={t('global.type')}
                            options={groupPageOptions}
                            borderStyle="rounded"
                        />
                    </Spacer>
                )}

                <div>
                    <Spacer spacing="small">
                        <Setting
                            subtitle="entity-group.menu"
                            helper="entity-group.menu-helper"
                        />
                        <DragDropContext onDragEnd={onDragEnd}>
                            <NavigationMenu
                                menu={menu}
                                groupPageOptions={groupPageOptions}
                                onChangePage={handleChangePage}
                                onChangeLabel={handleChangeLabel}
                                onChangeAccess={handleChangeAccess}
                                onRemovePage={handleRemove}
                                onAddPage={handleClickAdd}
                                onDragEnd={onDragEnd}
                                id="menu"
                                droppableId="droppable"
                                type="MENU"
                                style={{
                                    marginLeft: '-20px',
                                    marginRight: '-20px',
                                }}
                            />
                        </DragDropContext>
                    </Spacer>

                    <Button
                        size="normal"
                        variant="secondary"
                        onClick={handleClickAdd}
                        style={{ marginTop: '16px' }}
                    >
                        {t('action.add-item')}
                    </Button>
                </div>
            </Spacer>
        </Container>
    )
}

export default NavigationTab
